import { StorageKey } from '@/enums';
import axios from 'axios';
import store from '@/store';
import CryptoService from './crypto-services';
import StoragService from './storage-service';
import { StoreFunctions } from '@/constants';

const cryptoService = new CryptoService();
const gatewayURL = process.env.VUE_APP_GATEWAY_BASE_URL;



const storageService = new StoragService();
export default class RequestHelperService {
    defaultUIDefIDKey: string = process.env.VUE_APP_UI_DEF_ID || '';
    defaultCustomerKey: string = process.env.VUE_APP_CUSTOMER_ID || '';
    baseURL = process.env.VUE_APP_GATEWAY_BASE_URL;

    localStorageAgrislicense = {
        username: '',
        password: '',
        beforeEncrptPassword: '',
        agrisLicense: ''
    };

    private headers = null;

    async GetAgentSessionId(SessionID = null): Promise<any> {
        var agentInfo = store.getters.getAgentInfo;
        var appName = "ActionList";

        let data: any = await this.GetActivation(agentInfo.AgentEmail, agentInfo.AgentPassword, appName);
        let payload: any;
        if (data && data.MoreInfo) {
            agentInfo.AgentId = data.MoreInfo.AgentId;
            agentInfo.AgentUserName = data.MoreInfo.UserName;
            agentInfo.Password = data.MoreInfo.Password;
            store.commit("setAgentInfo", agentInfo);

            payload = {
                Password: data.MoreInfo.Password,
                Username: data.MoreInfo.UserName,
                DeviceName: "HOPPER",
                SessionID: SessionID,
                CustomerID: "C93F949C-41B8-4C9E-95AA-B030B31F6F3F",
                UIDefID: '45366299-9083-497b-8343-a8f701521358',
                // CustomerID: this.defaultUIDefIDKey,
                // UIDefID: this.defaultCustomerKey,
            };

            let promise = new Promise((resolve: any, reject: any) => {
                axios.post(`${gatewayURL}/culturahub/RESTSecurityWebService/Authenticate`, payload, { headers: { SessionID: SessionID } })
                    .then((response: any) => {
                        let agentInfo = store.getters.getAgentInfo;
                        if (response && response.data) {
                            agentInfo.SessionID = response.data.SessionID;
                            if (agentInfo.SessionID)
                                agentInfo.agentSessionDate = new Date().toLocaleDateString();
                            store.commit(StoreFunctions.setAgentInfo, agentInfo);
                            resolve(agentInfo.SessionID);
                        }
                    }).catch(e => {
                        let agentInfo = store.getters.getUserInfo;
                        resolve(agentInfo.SessionID);
                    });
            });

            return promise;
        }
        return null;
    }

    public getAgrisLicense(userId: any, password: any, beforeEncrptPassword: any, callback: any) {
        let userInfo = store.getters.getUserInfo;
        let tenantId = userInfo.TenantId;
        this.PostCommand(`${gatewayURL}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/GetLicense?TenantID=${tenantId}&UserID=${userId}&Password=${encodeURIComponent(password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12`, {});
    }

    async refreshAgrisLicenseCounter(): Promise<boolean> {
        let res: boolean = false;
        let userInfo = store.getters.getUserInfo;

        let refreshLicense = storageService.get(StorageKey.RefreshAgrisLicense);
        console.log("refreshLicense => ", refreshLicense);
        if (refreshLicense === 'true') {
            res = true;
        }

        storageService.set(StorageKey.RefreshAgrisLicense, "true");
        let response: any = await this.refreshAgrisLicense();
        storageService.set(StorageKey.RefreshAgrisLicense, "false");

        if (response == true)
            res = true;


        return res;
        // reject('License count exceeded. To continue using the app, contact your administrator to ensure there are enough licenses available before retrying.');
    }

    getDataFromAgentGateway(url: string, headers: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(url, { headers: headers })
                .then((response: any) => {
                    if (response && response.status == 200) {
                        resolve(response.data);
                    }
                    else
                        reject(null);
                }).catch(async e => {
                    if (e.response && e.response.data && e.response.data.Code) {
                        if (e.response.data.Code == 401) {
                            let sessionId = await this.GetAgentSessionId();
                            if (sessionId) {
                                headers.SessionID = sessionId;
                                this.getDataFromAgentGateway(url, headers);
                                resolve(true);
                            }
                            else
                                reject(null);

                        }
                        else if (e.response.data.Code == 404) {
                            resolve([]);
                        }
                    }
                    reject(e);
                });

        })
    }

    postDataToAgentGateway(url: string, payload: any = {}, headers: any) {
        let self = this;
        return new Promise((resolve, reject) => {

            axios.post(url, payload, { headers: headers })
                .then((response: any) => {
                    if (response && response.status == 200) {
                        resolve(response);
                    }
                    else
                        reject(null);
                }).catch(async e => {
                    if (e.response && e.response.data && e.response.data.Code) {
                        if (e.response.data.Code == 401) {
                            let sessionId = await self.GetAgentSessionId();
                            if (sessionId) {
                                headers.SessionID = sessionId;
                                self.postDataToAgentGateway(url, payload, headers);
                                resolve(true);
                            }
                            else
                                reject(null);
                        }
                    }

                    reject(e);
                });

        })
    }


    private async refreshAgrisLicense() {
        let reponse: boolean = false;
        try {
            var agentInfo = store.getters.getAgentInfo;
            var userInfo = store.getters.getUserInfo;

            let tenantId = agentInfo.TenantId;
            this.localStorageAgrislicense = {
                username: userInfo.userEmail,
                password: userInfo.Password,
                beforeEncrptPassword: '6',
                agrisLicense: userInfo.AgrisSessionId
            };

            if (!this.localStorageAgrislicense.username)
                reponse = false;

            let agrisLicense: any = this.localStorageAgrislicense || {};
            let url = `${gatewayURL}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/RefreshLicense?TenantID=${tenantId}&UserID=${agrisLicense.username}&Password=${encodeURIComponent(agrisLicense.password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12&AgrisSessionId=${agrisLicense.agrisLicense}`;

            let response: any = await this.PostCommand(url, {});
            if (response && response.Message == "True") {
                let license = {
                    username: agrisLicense.username,
                    password: agrisLicense.password,
                    beforeEncrptPassword: agrisLicense.beforeEncrptPassword,
                    agrisLicense: response.ResultString
                };
                Object.assign(this.localStorageAgrislicense, license);
                let userInfo = store.getters.getAgentInfo;
                userInfo.AgrisSessionId = this.localStorageAgrislicense.agrisLicense;
                store.commit(StoreFunctions.SetUserInfo, userInfo);
                reponse = true;
            }
        } catch (ex) {
            reponse = false;
            console.log(ex);
        }

        return reponse;

    }

    PostCommand(remoteURL: string, payload: any, headers: any = null): Promise<any> {
        if (payload) {
            var agentInfo = store.getters.getAgentInfo;
            var userInfo = store.getters.getUserInfo;

            payload.User = userInfo.userEmail;
            payload.Password = userInfo.Password;
            payload.AgrisSession = userInfo.AgrisSessionId;
            payload.SessionId = agentInfo.SessionID;
            payload.TenantId = agentInfo.TenantId;

            headers = {
                SessionID: payload.SessionId,
            }
        } else {
            payload = { "CustomerID": "C93F949C-41B8-4C9E-95AA-B030B31F6F3F" }
        }
        return new Promise((resolve, reject) => {
            axios.post(`${remoteURL}`, payload, { headers: headers }).then(
                (response: any) => {
                    resolve(response.data);
                }).catch(e => {
                    reject(e);
                })
        });
    }
    async GetActivation(clientEmail: string, clientPassword: string, appName: string): Promise<any> {
        clientPassword = encodeURIComponent(clientPassword);
        // clientPassword = "Z%2BN26gMMUJQ3LJYaCWc9Pg%3D%3D";
        let adminSessionId = await this.GetAdminSessionId();
        if (adminSessionId) {
            try {
                let url = `${gatewayURL}/culturahub/RESTCommandWebService/ExecuteServerCommand/ActivationsCommandProcessor/ActivateApp?AgentEmail=${clientEmail}&AgentPassword=${clientPassword}&AppName=${appName}&AppVersion=1.0.0`;
                let response: any = await this.PostCommand(url, null, { SessionID: adminSessionId });
                if (response) {
                    return response;
                }
            } catch (e) {
                return e;
            }
        }
        return null;
    }
    GetAdminSessionId(): Promise<any> {
        let promise = new Promise((resolve, reject) => {
            let remoteURL = `${gatewayURL}/culturahub/RESTSecurityWebService/Authenticate`;
            axios.post(remoteURL, {
                Password: "TLJUFZIZQPB+u9y1mPfmSw==",
                Username: "apiAdmin",
                DeviceName: "HOPPER",
                UIDefID: this.defaultUIDefIDKey,
                CustomerID: this.defaultCustomerKey,
                SessionID: null
            }, { headers: this.headers }
            ).then(
                (response: any) => {
                    resolve(response.data.SessionID);
                }).catch(e => {
                    reject(e);
                })
        });
        return promise;
    }

}
